<template>
    <div>
        <h3 class="mt-6 mb-2">CHARTE D'ACCÈS À LA PLATEFORME</h3>
        <b>Je m'engage à :</b>
        <v-checkbox 
            :color="themeColor"
            v-model="localTerms.access"
            class="ml-4 mt-1"
        >
            <template v-slot:label>
                <div>Ne pas partager les liens d'accès à quiconque qui ne serait pas inscrit à ce parcours*</div>
            </template>
        </v-checkbox>
        <v-checkbox 
            :color="themeColor"
            v-model="localTerms.secret"
            class="ml-4 mt-n4"
        >
            <template v-slot:label>
                <div>
                    À respecter le principe du secret professionnel ou secret partagé afin
                    qu'aucune information ou partage ultérieur sur ce qui a été abordé durant ce parcours <br />
                    ne permette l'identification de la personne ou ne puisse engendrer une quelconque malveillance*
                </div>
            </template>
        </v-checkbox>
        <v-checkbox 
            :color="themeColor"
            v-model="localTerms.discreet"
            class="ml-4 mt-n4"
        >
            <template v-slot:label>
                <div>
                    À me tenir dans un lieu discret à l'abris de regards extérieurs lors ma participation*
                </div>
            </template>
        </v-checkbox>
        <v-checkbox 
            :color="themeColor"
            v-model="localTerms.sceenshots" 
            class="ml-4 mt-n4"
        >
            <template v-slot:label>
                <div style="display: flex; align-items: baseline;">
                    À ne procéder à aucune capture d'écran, photographie ou vidéo des participants
                    ou des supports (diaporama, exercices ou guide d'animation)*
                </div>
            </template>
        </v-checkbox>
        <p class="mt-2">
            Je comprends que cette démarche s'inscrit dans le cadre strict du respect des personnes et du matériel qui est mis à ma disposition.
            Le non-respect de l'intégralité de la charte donnera lieu à une interdiction d'accès à la plateforme, à ses contenus et à toute demande de remboursement.
        </p>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Object,
            required: true
        },
        isAja: {
            default: false
        }
    },
    computed: {
        themeColor() {
            return this.isAja ? '#4E983C' : 'primary'
        },
        localTerms: {
            get() {
                return this.value
            },
            set(val) {
                this.$emit('input', val)
            }
        }
    }
}
</script> 